
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { DynamicFormDialogComponent } from '../dynamic-form/dynamic-form-dialog/dynamic-form-dialog.component';
import { QuestionBase } from '../dynamic-form/shared/question-base';

export abstract class DialogButtonBase {
  private _dialogRef: MatDialogRef<DynamicFormDialogComponent>;

  constructor(public dialog: MatDialog, public snackBar: MatSnackBar) { }

  openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }

  openDialog(title: string, questions: Array<QuestionBase<any>>, config?: MatDialogConfig): void {
    config = Object.assign(new MatDialogConfig(), { width: '400px' }, config);

    this._dialogRef = this.dialog.open(DynamicFormDialogComponent, config);
    this._dialogRef.componentInstance.title = title;
    this._dialogRef.componentInstance.questions = questions;
    this._dialogRef.componentInstance.submit.subscribe(this.onSubmit.bind(this));
  }

  closeDialog(): void {
    this._dialogRef.close();
  }

  abstract onSubmit(value: any);
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/dialog-button-base.ts